import { useAppContext } from 'contexts/app-context/hooks'
import { traceData, TraceDataProps } from 'common/services/trace'
import { Routes } from 'common/constants'

import { TUseErrorHandler } from '../types/ErrorHandler.types'

export function useErrorHandler({ componentName, traceDetails, goTo, to }: TUseErrorHandler) {
  const { userCountry, userAccountType, userLanguage, privacyCenterContent } = useAppContext()

  const userData = userCountry && userAccountType && userLanguage

  const traceContext: TraceDataProps['context'] =
    userData && privacyCenterContent?.entity
      ? {
          country: userCountry,
          userType: userAccountType,
          entity: privacyCenterContent.entity,
          language: userLanguage,
        }
      : undefined

  traceData({
    data: {
      transactionType: 'COMPONENT_RENDER',
      transactionSubType: componentName.toUpperCase(),
      detail: traceDetails,
      status: 'ERROR',
    },
    context: traceContext,
  })

  return { replace: true, goTo: goTo ?? Routes.ROOT, to: to ?? Routes.ERROR }
}
